export default __webpack_public_path__ + "static/media/21.34257193.png";